import { useLingui } from '@lingui/react';

import { detectLang, setLang } from './local';

export const useLocal = () => {
  useLingui();

  return [detectLang(), setLang] as const;
};
